const AssetAllocationsChart = require('okCharts/AssetAllocationsChart');

module.exports = AssetAllocationsChart;
